import React from "react";
import * as PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";

const styles = {
  container: {
    display: "flex"
  }
};

const PanelChart = props => (
  <div className={props.classes.container}>{props.children}</div>
);

PanelChart.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired
};

export default withStyles(styles)(PanelChart);
